(function () {
  function buildEmbedPlayUrl(idleSrc) {
    try {
      var u = new URL(idleSrc);
      var host = u.hostname;
      if (host.indexOf('youtube.com') !== -1 || host === 'youtu.be') {
        u.searchParams.set('autoplay', '1');
        u.searchParams.set('mute', '1');
        return u.toString();
      }
      if (host.indexOf('vimeo.com') !== -1) {
        u.searchParams.set('autoplay', '1');
        u.searchParams.set('muted', '1');
        return u.toString();
      }
    } catch (e) {}
    return idleSrc;
  }

  function initHoverPlay(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;

    root.querySelectorAll('.video-reel__item').forEach(function (item) {
      if (item.dataset.videoReelHoverInit) return;
      item.dataset.videoReelHoverInit = 'true';

      var media = item.querySelector('.video-reel__media');
      if (!media) return;

      var video = media.querySelector('video');
      var iframe = media.querySelector('iframe');

      if (iframe && iframe.src && iframe.src.indexOf('instagram.com') !== -1) {
        return;
      }

      var idleSrc = '';
      if (iframe) {
        idleSrc = iframe.getAttribute('data-video-reel-idle-src') || iframe.src;
        if (!iframe.getAttribute('data-video-reel-idle-src')) {
          iframe.setAttribute('data-video-reel-idle-src', idleSrc);
        }
      }

      if (!video && !iframe) return;

      function play() {
        if (video) {
          video.muted = true;
          video.play().catch(function () {});
          return;
        }
        if (iframe && idleSrc) {
          var playSrc = buildEmbedPlayUrl(idleSrc);
          if (playSrc !== iframe.src) {
            iframe.src = playSrc;
          }
        }
      }

      function pause() {
        if (video) {
          video.pause();
          try {
            video.currentTime = 0;
          } catch (e) {}
          return;
        }
        if (iframe && idleSrc && iframe.src !== idleSrc) {
          iframe.src = idleSrc;
        }
      }

      item.addEventListener('pointerenter', play);
      item.addEventListener('pointerleave', pause);
    });
  }

  function initVideoReel(root) {
    var track = root.querySelector('[data-video-reel-track]');
    if (!track || root.getAttribute('data-autoplay') !== 'true') return;

    var intervalMs = Math.max(2000, parseInt(root.getAttribute('data-interval') || '4000', 10));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var timer = null;

    function clearTimer() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startTimer() {
      clearTimer();
      timer = setInterval(tick, intervalMs);
    }

    function tick() {
      var slides = track.querySelectorAll('.video-reel__item');
      if (slides.length < 2) return;

      var first = slides[0];
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      var step = first.offsetWidth + gap;
      var maxScroll = track.scrollWidth - track.clientWidth;

      if (maxScroll <= 0) return;

      if (track.scrollLeft >= maxScroll - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollTo({ left: track.scrollLeft + step, behavior: 'smooth' });
      }
    }

    function pause() {
      clearTimer();
    }

    function resume() {
      if (document.hidden) return;
      startTimer();
    }

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', resume);
    track.addEventListener('focusin', pause);
    track.addEventListener('focusout', resume);
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', resume, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else resume();
    });

    startTimer();
  }

  function boot() {
    document.querySelectorAll('[data-video-reel-root]').forEach(function (root) {
      initHoverPlay(root);
      initVideoReel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
